import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import "./style.css";

import Navbar from "../../../components/Landing_page_Navbar/index"
import Hero from "./components/Hero";
import GuidelineSections from "./components/GuidelineSections";
import AboutGuide from "./components/AboutGuide";
import Troubleshooting from "./components/Troubleshooting";
import SupportContact from "./components/SupportContact";
import GettingStarted from "./components/GettingStarted";
import PlatformFeatures from "./components/PlatformFeatures";
import Modules from "./components/Modules";
import Footer from "./components/Footer";

export default function Guidelines() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const updateBackToTopVisibility = () => {
      setShowBackToTop(window.scrollY > 320);
    };

    updateBackToTopVisibility();
    window.addEventListener("scroll", updateBackToTopVisibility, {
      passive: true,
    });
    return () =>
      window.removeEventListener("scroll", updateBackToTopVisibility);
  }, []);

  return (
    <div className="sz-app">
      <Navbar />
      <Hero />
      <GuidelineSections />
      <AboutGuide />
      <Troubleshooting />
      <SupportContact />
      <GettingStarted />
      <PlatformFeatures />
      <Modules />
      <Footer />
      <button
        type="button"
        className={`sz-guideline-back-to-top${showBackToTop ? " sz-guideline-back-to-top--visible" : ""}`}
        aria-label="Back to top"
        title="Back to top"
        tabIndex={showBackToTop ? 0 : -1}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <ArrowUp size={21} strokeWidth={2.2} aria-hidden="true" />
      </button>
    </div>
  );
}
